const firebaseConfig = {

    apiKey: "AIzaSyAryv1OoX2SE-W3SxVGMTgMCzewavlMwik",

    authDomain: "aspirehive-12753.firebaseapp.com",

    projectId: "aspirehive-12753",

    storageBucket: "aspirehive-12753.appspot.com",

    messagingSenderId: "724282800145",

    appId: "1:724282800145:web:db9a909fa335a6fc4919b0"

};
export default firebaseConfig;